import _extends from "@babel/runtime/helpers/extends";
import MuiListItem from "@material-ui/core/ListItem";
import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import Avatar from "../Avatar";
import ListItemAvatar from "../ListItemAvatar";
import ListItemIcon from "../ListItemIcon";
import ListItemSecondaryAction from "../ListItemSecondaryAction";
import ListItemText from "../ListItemText";
import { makeStyles, useTheme } from "../Utilities/ThemeHelper";
const useStyles = makeStyles(theme => ({
  sideNavItem: {
    textTransform: "none",
    padding: theme.spacing(1.5, 4),
    letterSpacing: 0,
    wordWrap: "break-word",
    "&:before": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: 0,
      width: ".33rem",
      height: "75%",
      display: "block",
      background: "transparent",
      transform: "translateY(-16%)",
      transition: theme.transitions.create("background")
    },
    "&:hover": {
      background: theme.palette.action.hover
    },
    "&$selected": {
      "&:before": {
        background: theme.palette.primary.main
      }
    }
  },
  selected: {},
  buttonItem: {
    textTransform: "capitalize"
  }
}));
export const ListItem = props => {
  const {
    id,
    isSideNav,
    itemSideNav,
    dataId,
    className,
    itemAvatar,
    ListItemAvatarProps,
    itemIcon,
    ListItemIconProps,
    iconLocation,
    itemSecondaryAction,
    ListItemSecondaryActionProps,
    itemText,
    ListItemTextProps,
    button,
    AvatarProps,
    hide,
    openInNewWindow,
    target,
    style,
    ...otherProps
  } = props;
  const classes = useStyles();
  const theme = useTheme();
  const actionRef = useRef(null);
  const [paddingLeft, setPaddingLeft] = useState(0);
  useEffect(() => {
    if (actionRef.current) {
      const paddingLeft = props.disableGutters ? 0 : theme.spacing(2);
      const width = actionRef.current.offsetWidth + paddingLeft;
      setPaddingLeft(width);
    }
  }, [props.disableGutters, theme]);
  let renderedAvatar = itemAvatar;
  if (ListItemAvatarProps?.children) renderedAvatar = ListItemAvatarProps.children;
  const iconSection = /*#__PURE__*/React.createElement(React.Fragment, null, renderedAvatar && /*#__PURE__*/React.createElement(ListItemAvatar, _extends({
    id: ListItemAvatarProps?.id || id ? `listItemAvatar-${id}` : undefined
  }, ListItemAvatarProps), /*#__PURE__*/React.createElement(Avatar, _extends({
    id: AvatarProps?.id || id ? `avatar-${id}` : undefined,
    size: "medium"
  }, AvatarProps), AvatarProps?.children || renderedAvatar)), (ListItemIconProps?.children || itemIcon) && /*#__PURE__*/React.createElement(ListItemIcon, _extends({
    id: ListItemIconProps?.id || id ? `listItemIcon-${id}` : undefined
  }, ListItemIconProps), ListItemIconProps?.children || itemIcon));
  const textSection = /*#__PURE__*/React.createElement(ListItemText, _extends({
    id: itemText?.id || ListItemTextProps?.id || id ? `listItemText-${id}` : undefined
  }, itemText, ListItemTextProps));
  const actionSection = /*#__PURE__*/React.createElement(ListItemSecondaryAction, _extends({
    ref: actionRef,
    id: ListItemSecondaryActionProps?.id || id ? `listItemSecondaryAction-${id}` : undefined
  }, ListItemSecondaryActionProps), ListItemSecondaryActionProps?.children || itemSecondaryAction);
  return hide ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement(MuiListItem, _extends({
    "data-id": dataId,
    id: id
  }, otherProps, {
    classes: {
      ...otherProps.classes,
      selected: classNames(otherProps.classes?.selected, classes.selected)
    },
    className: classNames("prmbl-listItem", className, {
      [classes.sideNavItem]: isSideNav || itemSideNav,
      [classes.buttonItem]: button
    }),
    style: {
      // Dynamic padding left based on the width of the action section
      paddingRight: actionSection ? paddingLeft : undefined,
      ...style
    },
    button: button,
    target: openInNewWindow ? "_blank" : target,
    component: otherProps.component ? otherProps.component : button ? "button" : undefined
  }), iconLocation === "left" ? iconSection : undefined, textSection, iconLocation === "right" ? iconSection : undefined, actionSection);
};
ListItem.defaultProps = {
  iconLocation: "left"
};
export default ListItem;